<template>
  <router-link to="/">
    <div>
      <div class="logo">
        <img :src="link" alt="logo"/>
      </div>
    </div>
  </router-link>
</template>
<script setup>
import {computed} from "vue";

const link = computed(() => {
  return process.env.VUE_APP_LOGO_PATH
})
</script>
<style scoped>
.logo {
  display: flex;
  align-items: center;
}
</style>